if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => {
    document.body.classList.add('font-loaded');
    document.getElementById('loader').classList.add('loaded');
    document.getElementById('site-wrapper').classList.add('font-loaded');
  });
}